// External libraries
import gql from 'graphql-tag';

const ADDRESS_NORMALIZATION_QUERY = gql`
  query GetAddressNormalizationQuery(
    $city: String
    $country: CountryCodes
    $line1: String
    $line2: String
    $postalCode: String
    $state: String
    $token: String!
  ) {
    addressNormalization(
      city: $city
      country: $country
      line1: $line1
      line2: $line2
      postalCode: $postalCode
      state: $state
      token: $token
    ) {
      line1
      line2
      city
      state
      postalCode
      alreadyNormalized
      griffinFormattedAddresses {
        formattedOriginalAddress
        formattedNormalizedAddress
      }
    }
  }
`;

export { ADDRESS_NORMALIZATION_QUERY };
